module.exports = __webpack_public_path__ + "static/media/corporate-services-img13.ba653a92.jpg";